'use strict';

var _inherits = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _classCallCheck = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/createClass.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EventEmitter = require('eventemitter3'); // Port of lower_bound from http://en.cppreference.com/w/cpp/algorithm/lower_bound
// Used to compute insertion index to keep queue sorted after insertion


function lowerBound(array, value, comp) {
  var first = 0;
  var count = array.length;

  while (count > 0) {
    var step = count / 2 | 0;
    var it = first + step;

    if (comp(array[it], value) <= 0) {
      first = ++it;
      count -= step + 1;
    } else {
      count = step;
    }
  }

  return first;
}

var PriorityQueue = /*#__PURE__*/function () {
  function PriorityQueue() {
    _classCallCheck(this, PriorityQueue);

    this._queue = [];
  }

  _createClass(PriorityQueue, [{
    key: "enqueue",
    value: function enqueue(run, options) {
      options = Object.assign({
        priority: 0
      }, options);
      var element = {
        priority: options.priority,
        run: run
      };

      if (this.size && this._queue[this.size - 1].priority >= options.priority) {
        this._queue.push(element);

        return;
      }

      var index = lowerBound(this._queue, element, function (a, b) {
        return b.priority - a.priority;
      });

      this._queue.splice(index, 0, element);
    }
  }, {
    key: "dequeue",
    value: function dequeue() {
      return this._queue.shift().run;
    }
  }, {
    key: "size",
    get: function get() {
      return this._queue.length;
    }
  }]);

  return PriorityQueue;
}();

var PQueue = /*#__PURE__*/function (_EventEmitter) {
  _inherits(PQueue, _EventEmitter);

  var _super = _createSuper(PQueue);

  function PQueue(options) {
    var _this;

    _classCallCheck(this, PQueue);

    _this = _super.call(this);
    options = Object.assign({
      carryoverConcurrencyCount: false,
      intervalCap: Infinity,
      interval: 0,
      concurrency: Infinity,
      autoStart: true,
      queueClass: PriorityQueue
    }, options);

    if (!(typeof options.concurrency === 'number' && options.concurrency >= 1)) {
      throw new TypeError("Expected `concurrency` to be a number from 1 and up, got `".concat(options.concurrency, "` (").concat(typeof options.concurrency, ")"));
    }

    if (!(typeof options.intervalCap === 'number' && options.intervalCap >= 1)) {
      throw new TypeError("Expected `intervalCap` to be a number from 1 and up, got `".concat(options.intervalCap, "` (").concat(typeof options.intervalCap, ")"));
    }

    if (!(Number.isFinite(options.interval) && options.interval >= 0)) {
      throw new TypeError("Expected `interval` to be a finite number >= 0, got `".concat(options.interval, "` (").concat(typeof options.interval, ")"));
    }

    _this._carryoverConcurrencyCount = options.carryoverConcurrencyCount;
    _this._isIntervalIgnored = options.intervalCap === Infinity || options.interval === 0;
    _this._intervalCount = 0;
    _this._intervalCap = options.intervalCap;
    _this._interval = options.interval;
    _this._intervalId = null;
    _this._intervalEnd = 0;
    _this._timeoutId = null;
    _this.queue = new options.queueClass(); // eslint-disable-line new-cap

    _this._queueClass = options.queueClass;
    _this._pendingCount = 0;
    _this._concurrency = options.concurrency;
    _this._isPaused = options.autoStart === false;

    _this._resolveEmpty = function () {};

    _this._resolveIdle = function () {};

    return _this;
  }

  _createClass(PQueue, [{
    key: "_doesIntervalAllowAnother",
    get: function get() {
      return this._isIntervalIgnored || this._intervalCount < this._intervalCap;
    }
  }, {
    key: "_doesConcurrentAllowAnother",
    get: function get() {
      return this._pendingCount < this._concurrency;
    }
  }, {
    key: "_next",
    value: function _next() {
      this._pendingCount--;

      this._tryToStartAnother();
    }
  }, {
    key: "_resolvePromises",
    value: function _resolvePromises() {
      this._resolveEmpty();

      this._resolveEmpty = function () {};

      if (this._pendingCount === 0) {
        this._resolveIdle();

        this._resolveIdle = function () {};
      }
    }
  }, {
    key: "_onResumeInterval",
    value: function _onResumeInterval() {
      this._onInterval();

      this._initializeIntervalIfNeeded();

      this._timeoutId = null;
    }
  }, {
    key: "_intervalPaused",
    value: function _intervalPaused() {
      var _this2 = this;

      var now = Date.now();

      if (this._intervalId === null) {
        var delay = this._intervalEnd - now;

        if (delay < 0) {
          // Act as the interval was done
          // We don't need to resume it here,
          // because it'll be resumed on line 160
          this._intervalCount = this._carryoverConcurrencyCount ? this._pendingCount : 0;
        } else {
          // Act as the interval is pending
          if (this._timeoutId === null) {
            this._timeoutId = setTimeout(function () {
              return _this2._onResumeInterval();
            }, delay);
          }

          return true;
        }
      }

      return false;
    }
  }, {
    key: "_tryToStartAnother",
    value: function _tryToStartAnother() {
      if (this.queue.size === 0) {
        // We can clear the interval ("pause")
        // because we can redo it later ("resume")
        clearInterval(this._intervalId);
        this._intervalId = null;

        this._resolvePromises();

        return false;
      }

      if (!this._isPaused) {
        var canInitializeInterval = !this._intervalPaused();

        if (this._doesIntervalAllowAnother && this._doesConcurrentAllowAnother) {
          this.emit('active');
          this.queue.dequeue()();

          if (canInitializeInterval) {
            this._initializeIntervalIfNeeded();
          }

          return true;
        }
      }

      return false;
    }
  }, {
    key: "_initializeIntervalIfNeeded",
    value: function _initializeIntervalIfNeeded() {
      var _this3 = this;

      if (this._isIntervalIgnored || this._intervalId !== null) {
        return;
      }

      this._intervalId = setInterval(function () {
        return _this3._onInterval();
      }, this._interval);
      this._intervalEnd = Date.now() + this._interval;
    }
  }, {
    key: "_onInterval",
    value: function _onInterval() {
      if (this._intervalCount === 0 && this._pendingCount === 0) {
        clearInterval(this._intervalId);
        this._intervalId = null;
      }

      this._intervalCount = this._carryoverConcurrencyCount ? this._pendingCount : 0;

      while (this._tryToStartAnother()) {} // eslint-disable-line no-empty

    }
  }, {
    key: "add",
    value: function add(fn, options) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var run = function run() {
          _this4._pendingCount++;
          _this4._intervalCount++;

          try {
            Promise.resolve(fn()).then(function (val) {
              resolve(val);

              _this4._next();
            }, function (err) {
              reject(err);

              _this4._next();
            });
          } catch (error) {
            reject(error);

            _this4._next();
          }
        };

        _this4.queue.enqueue(run, options);

        _this4._tryToStartAnother();
      });
    }
  }, {
    key: "addAll",
    value: function addAll(fns, options) {
      var _this5 = this;

      return Promise.all(fns.map(function (fn) {
        return _this5.add(fn, options);
      }));
    }
  }, {
    key: "start",
    value: function start() {
      if (!this._isPaused) {
        return;
      }

      this._isPaused = false;

      while (this._tryToStartAnother()) {} // eslint-disable-line no-empty

    }
  }, {
    key: "pause",
    value: function pause() {
      this._isPaused = true;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.queue = new this._queueClass();
    }
  }, {
    key: "onEmpty",
    value: function onEmpty() {
      var _this6 = this;

      // Instantly resolve if the queue is empty
      if (this.queue.size === 0) {
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        var existingResolve = _this6._resolveEmpty;

        _this6._resolveEmpty = function () {
          existingResolve();
          resolve();
        };
      });
    }
  }, {
    key: "onIdle",
    value: function onIdle() {
      var _this7 = this;

      // Instantly resolve if none pending and if nothing else is queued
      if (this._pendingCount === 0 && this.queue.size === 0) {
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        var existingResolve = _this7._resolveIdle;

        _this7._resolveIdle = function () {
          existingResolve();
          resolve();
        };
      });
    }
  }, {
    key: "size",
    get: function get() {
      return this.queue.size;
    }
  }, {
    key: "pending",
    get: function get() {
      return this._pendingCount;
    }
  }, {
    key: "isPaused",
    get: function get() {
      return this._isPaused;
    }
  }]);

  return PQueue;
}(EventEmitter);

module.exports = PQueue;
module.exports.default = PQueue;